import { useQuery } from '@tanstack/react-query';
import httpClient from '../services/http-client';
import { OrderActivityLog } from '../types';

/**
 * Fetches the flat, time-ordered activity log for an order.
 * Admin-only endpoint — includes approval decisions, emails sent, and approvers added.
 */
export function useOrderActivityLog(divisionId: string, orderId: string, enabled: boolean = true) {
  return useQuery<OrderActivityLog>({
    queryKey: ['order-activity-log', divisionId, orderId],
    queryFn: async () => {
      const response = await httpClient.get<OrderActivityLog>(
        `/api/v1.0/divisions/${divisionId}/orders/${orderId}/activity-log`
      );
      return response;
    },
    enabled: enabled && !!divisionId && !!orderId,
    staleTime: 1000 * 30, // 30 seconds — activity log changes during workflow execution
  });
}
